import * as Dashboard from "./dashboard"

export const dashboardCallJs = Dashboard.dashboardCallJs



// WEBPACK FOOTER //
// ./src/analytics/analytics.ts